import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const billingPageReducer = (state = initialState.billingPage, action) => {
  switch (action.type) {
    case actionTypes.billingPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default billingPageReducer;
